import React from 'react';
import {useRoute} from '@react-navigation/native';
import {LeaderboardContainer} from './containers/LeaderboardContainer';
import {LeaderboardType, leaderboardTypeList} from './config';

const Leaderboard = () => {
  const route = useRoute();
  const routeType = (route.params as any)?.type;

  // 从URL路径参数获取type，验证是否为有效类型，如果没有或无效则默认为NEW_USER_RANK_ACTIVITY
  const type = (
    leaderboardTypeList.includes(routeType)
      ? routeType
      : 'NEW_USER_RANK_ACTIVITY'
  ) as LeaderboardType;
  return <LeaderboardContainer type={type} />;
};

export default Leaderboard;
